import {request} from "../shared/httpInterceptor";
import {useCountryLang} from "./useCountryLang";
import {useQuery} from '@tanstack/react-query';

type PrivateRegisterInitType = {
  birthDate: { required?: boolean };
  careOf?: { required?: boolean };
  city: { required?: boolean };
  digicode: { required?: boolean};
  countryCode: { required?: boolean };
  firstName: { required?: boolean };
  gender: { required?: boolean };
  lastName: { required?: boolean };
  loginEmail: { required?: boolean };
  loginPassword: { required?: boolean };
  confirmPassword: { required?: boolean };
  mobilePhoneNumber: { required?: boolean };
  mobilePhoneNumberCountry?: { required?: boolean };
  newsletterMode: { required?: boolean };
  postbox?: { required?: boolean };
  postcode: { required?: boolean };
  street: { required?: boolean };
  username?: { required?: boolean };
}

export const fetchPrivateInit = async (countryLang: string | null, host?: string) => {
  const res = await request({
    url: `/${countryLang}/register/private/init`,
    method: 'get',
    host: host
  });
  console.log(res.data)
  return res.data;
}

const usePrivateRegisterInit = () => {
  const countryLang = useCountryLang()
  return useQuery<PrivateRegisterInitType>(["private-register-init", countryLang], () => fetchPrivateInit(countryLang), {
    enabled: countryLang != null
  });
}

export default usePrivateRegisterInit;
